var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcnAccountDetail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "8px",
    height: "9px",
    viewBox: "0 0 8 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "715D1DEA-C31F-4FBD-86C1-6570502FE98E") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Coach-Mvp",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard-Messages-&-Notification-Copy",
    transform: "translate(-1683.000000, -98.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(1656.000000, 76.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn_account_detail",
    transform: "translate(16.926407, 22.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5422431,0 L13.2698864,1.02272727 C13.0227848,1.09599043 12.7875308,1.20025837 12.5695405,1.33373206 L11.708004,0.81937799 L10.9354002,1.6507177 L11.413414,2.5777512 C11.2893848,2.81227943 11.1924551,3.06546603 11.1243824,3.33133971 L10.173913,3.62440191 L10.173913,4.79665072 L11.1243824,5.08971292 C11.1924551,5.35560957 11.2893848,5.60873684 11.413414,5.84330144 L10.9354002,6.7703445 L11.708004,7.60167464 L12.5695405,7.08732057 C12.7875308,7.22079426 13.0227848,7.32508134 13.2698864,7.39832536 L13.5422431,8.42105837 L14.63167,8.42105837 L14.9040267,7.39832536 C15.1511265,7.32508134 15.3863822,7.22079426 15.6043725,7.08732057 L16.4659091,7.60167464 L17.2385128,6.7703445 L16.760499,5.84330144 C16.88453,5.60873684 16.9814561,5.35560957 17.0495306,5.08971292 L18,4.79665072 L18,3.62440191 L17.0495306,3.33133971 C16.9814561,3.06546603 16.88453,2.81227943 16.760499,2.5777512 L17.2385128,1.6507177 L16.4659091,0.81937799 L15.6043725,1.33373206 C15.3863822,1.20025837 15.1511265,1.09599043 14.9040267,1.02272727 L14.63167,0 L13.5422431,0 Z M14.0869565,2.8708134 C14.7745832,2.8708134 15.3320158,3.47062967 15.3320158,4.21052632 C15.3320158,4.95042488 14.7745832,5.5502488 14.0869565,5.5502488 C13.3993298,5.5502488 12.8418972,4.95042488 12.8418972,4.21052632 C12.8418972,3.47062967 13.3993298,2.8708134 14.0869565,2.8708134 Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnAccountDetail);
export default __webpack_public_path__ + "static/media/icn_account_detail.e973d43a42381ba3eb00edfabbdb0a59.svg";
export { ForwardRef as ReactComponent };